import type { Observable } from 'rxjs';
import type { PromoCode } from '@integrations/promo-codes/contracts/promo-code.contract';

import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { CRM_SERVICE_API_BASE } from '@integrations/crm-pipelines';
import { parseResponse } from '@integrations/shared/parse-response';
import {
    PromoCodeCollectionResponseSchema,
    salvagePromoCodes,
} from '@integrations/promo-codes/contracts/promo-code.contract';

@Injectable({ providedIn: 'root' })
export class PromoCodesApiService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = inject(CRM_SERVICE_API_BASE);

    public getPromoCodes(): Observable<PromoCode[]> {
        return this.http.get<unknown>(`${this.baseUrl}/promo-code`).pipe(
            map((res) => {
                const parsed = parseResponse(res, PromoCodeCollectionResponseSchema, {
                    endpoint: 'crm/promo-code',
                    method: 'GET',
                });

                // Non-strict `parseResponse` passes an unrecognised payload straight
                // through; consumers iterate the result, so keep the contract's array
                // promise even then (the mismatch is already reported to Sentry) and
                // salvage the records that are usable instead of dropping all of them.
                return Array.isArray(parsed) ? parsed : salvagePromoCodes(res);
            })
        );
    }
}
